/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { create } from "@github/webauthn-json";
import axios from "axios";
import { AppThunk } from "../../../../config/store";
import { getUser } from "../../../login/ducks/operations";
import { WebAuthnSettingActions } from "./slices";
import { webAuthnApi } from "../../../../config/api";
import { RegistrationRequestResponse } from "@advapacs/common";

export interface WebAuthnRegistrationResponse {
  id: string;
  name: string;
  createdAt: Date;
}

export const deleteWebAuthnRegistration =
  (registerdCredential: WebAuthnRegistrationResponse): AppThunk =>
  async (dispatch) => {
    try {
      await axios.delete(
        `${webAuthnApi.REGISTRATIONS}/${registerdCredential.id}`
      );
      dispatch(WebAuthnSettingActions.unregisterDevice(registerdCredential));
    } catch (error) {
      dispatch(WebAuthnSettingActions.failure(error));
    }
  };

export const loadWebAuthnRegistrations = (): AppThunk => async (dispatch) => {
  try {
    dispatch(WebAuthnSettingActions.start());
    const response = await axios.get(webAuthnApi.REGISTRATIONS);
    dispatch(
      WebAuthnSettingActions.setRegisteredDevices(response.data.content)
    );
    dispatch(WebAuthnSettingActions.success());
  } catch (error) {
    dispatch(WebAuthnSettingActions.failure(error.data));
  }
};

export const executeRegisterRequest =
  (credentialName: string, authenticatorType: string): AppThunk =>
  async (dispatch) => {
    dispatch(WebAuthnSettingActions.start());
    let response;
    try {
      response = await axios.post(webAuthnApi.REGISTRATION_REQUEST, {
        authenticatorType,
      });
    } catch (error) {
      dispatch(WebAuthnSettingActions.failure(error.data));
    }
    if (!response) {
      return;
    }
    try {
      const {
        credentialCreationOptions,
        requestId,
      }: RegistrationRequestResponse = JSON.parse(response.data.content);
      const createOptions = JSON.parse(credentialCreationOptions);
      const credential = await create(createOptions);
      const body = {
        name: credentialName,
        requestId,
        credential,
      };
      await axios.post(webAuthnApi.REGISTRATION_REGISTER_FINISH, {
        content: JSON.stringify(body),
      });
      dispatch(loadWebAuthnRegistrations());
      dispatch(WebAuthnSettingActions.finishRegisteringCredential());
      dispatch(WebAuthnSettingActions.success());
      if (window.location.pathname.indexOf("/UserSettings") < 0) {
        dispatch(getUser());
      }
    } catch (registerError) {
      dispatch(WebAuthnSettingActions.registerFailed(registerError));
    }
  };
